// PROPOSITO: las rutas de mantenimiento. Anthony y Sebastian.
// DEPENDENCIAS: react-router-dom, Guard.
// NO OBVIO: aqui NO hay ninguna ruta a fichas, fotos ni examenes, y tampoco hay politica de RLS que
// se lo permita. El admin ve altas, suscripciones y salud tecnica. Los datos de salud son de la
// alumna y de su entrenadora, de nadie mas. Si algun dia hace falta soporte sobre un dato clinico,
// se pide a Flor: no se abre una puerta.

import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Guard } from './Guard'

const SaludDeLaPlataforma = lazy(() => import('@/pages/admin/SaludDeLaPlataforma'))
const Suscripciones = lazy(() => import('@/pages/admin/Suscripciones'))

export const rutasDeAdmin: RouteObject[] = [
  {
    element: <Guard permitidos={['admin_plataforma']} />,
    children: [
      { path: '/plataforma', element: <SaludDeLaPlataforma /> },
      { path: '/plataforma/suscripciones', element: <Suscripciones /> },
    ],
  },
]
